<template>
    <!-- 物流节点型 -->
    <div :class="['node-container', isShowLoadMoer ? 'limit-height' : '',isMobile ? '':'pc-node']" ref='container'>
        <div class="title">{{ content.title }}</div>
        <div class="subTitle" title="content.subTitledesc">{{ content.subTitledesc }}</div>
        <div class="list" v-for="(item, index) in content.list">
            <div class="list-icon">
                <div class="icon-dot"></div>
                <div v-if="index !== content.list.length - 1" class="icon-line"></div>
            </div>
            <div class="list-item">
                <div class="item-name">{{ item.name }}</div>
                <div class="item-desc">{{ item.desc }}</div>
            </div>
        </div>
        <div class="xml-more" v-if="isShowLoadMoer">
            <div :class='[isMobile ? "xml-more-h5":"xml-more-pc"]'></div>
            <div class="xml-more__btn" @click="loadMore">查看更多</div>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    message: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    content() {
      return this.message.content.content.content;
    },
    isMobile() {
      return !this.$platform.pc;
    },
  },
  data() {
    return {
      isShowLoadMoer: false,
    };
  },
  mounted() {
    this.isShowLoadMoer = this.$refs.container.offsetHeight > 340;
  },
  methods: {
    loadMore() {
      this.isShowLoadMoer = false;
    },
  },
};
</script>

<style lang="less" scoped>
.node-container {
    width: 100%;
    position: relative;
    overflow-y: hidden;

    .title {
        font-size: 16px;
        word-break: break-all;
        padding: 12px 0px;
        border-bottom: 1px solid rgba(240, 240, 240, 1);
    }

    .subTitle {
        font-size: 12px;
        word-break: break-all;
        padding: 14px 0px;
    }

    .list {
        display: flex;
        flex-direction: row;

        .list-icon {
            display: flex;
            width: 12px;
            margin: 0px 8px 0px 4px;
            flex-direction: column;
            align-items: center;

            .icon-dot {
                text-align: center;
                display: flex;
                width: 9px;
                height: 9px;
                background-color: rgba(213, 222, 255, 1);
                border-radius: 4.5px;
                flex-direction: row
            }

            .icon-line {
                display: block;
                width: 1px;
                height: 100%;
                background-color: rgba(213, 222, 255, 1)
            }
        }

        .list-item {
            display: flex;
            flex-grow: 1;
            margin: -5px 16px 16px 0px;
            flex-direction: column;
            max-width: 340px;

            .item-name {
                display: block;
                width: 100%;
                margin: 0px 0px 4px 0px;
                color: rgba(120, 132, 158, 1);
                font-size: 12px;
                word-break: break-all;
                overflow: hidden;
                flex-shrink: 0;
            }

            .item-desc {
                display: block;
                width: 100%;
                color: rgba(120, 132, 158, 1);
                font-size: 12px;
                word-break: break-all;
                overflow: hidden;
                flex-shrink: 0;

            }
        }
    }

    // 更多按钮样式
    .xml-more {
        position: absolute;
        bottom: 0;
        width: 100%;

        .xml-more-h5 {
            height: 40px;
            background-color: linear-gradient(180deg, rgba(255, 255, 255, 0.0001) 0%, #FFFFFF 100%);
        }

        .xml-more__btn {
            line-height: 40px;
            text-align: center;
            font-size: 13px;
            font-weight: 500;
            color: #4A70FF;
            background-color: #fff;
            cursor: pointer;
        }
    }
}

.limit-height {
    max-height: 340px;
}

.pc-node {
    .xml-more {
        .xml-more-pc {
            background: linear-gradient(180deg, rgba(255, 255, 255, 0.0001) 0%, #f1f2f5 100%);
        }

        .xml-more__btn {
            background-color: #f1f2f5;
        }
    }
}
</style>
